<template>
  

  <v-container fluid>

    <!--
    <v-card class="mx-auto" max-width="100%">
      <v-card-title class="text-h5 font-weight-bold">
        {{$t('simulaciones.manual_usuario')}}
      </v-card-title>
      <v-card-text>
        {{$t('simulaciones.parrafos[0]')}}
        <br><br>
        {{$t('simulaciones.parrafos[1]')}}
        <br>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="descargarReadme">
        {{$t('simulaciones.boton_manual')}}
      </v-btn>
      </v-card-actions>
    </v-card>
    -->
    <br>

      
      <ComponenteLoading :is-loading="loading" :message="mensaje_loading"></ComponenteLoading>


      
      <v-row align="center">


        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>

        <v-btn v-if="!vista_operador" color="secundary" dark class="rounded-0" @click="abrir_configuracion">
          <v-icon left>mdi-cog</v-icon>
          {{$t('simulaciones.boton.configuracion')}}
        </v-btn>
      </v-row>
  

      <br><br>


        <v-data-table
        density="compact"
        
        :headers="cabecera_tabla_simulaciones"
        :items="lista_simulaciones"
        :search="search"
        class="elevation-1"        
      >
        

      <template v-slot:top>
          
          <v-toolbar flat color="white" style="padding-bottom: 20px;"   >
            
            
            <v-toolbar-title class="mb-6"><div class="ml-5 mt-3 text-caption gris_suave"></div>{{$t('simulaciones.titulo')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
             
            <v-btn  class="boton_crear selected" dark @click="nueva_simulacion"><span class="material-symbols-outlined">add</span>{{$t('simulaciones.boton.nueva')}}</v-btn>
            <v-btn  class="gris_medio" @click="obtener_lista_simulaciones"><span class="material-symbols-outlined">autorenew</span>{{$t('simulaciones.boton.recargar')}}</v-btn>

              <v-text-field
                v-model="search"
                :placeholder="$t('simulaciones.busqueda')"
                density="comfortable"
                hide-details
                variant="solo-filled"
                prepend-inner-icon="mdi-magnify"
                class="campo-buscador pr-3"
               
            ></v-text-field>
            
  
          </v-toolbar>
         
        </template>


        <!--
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{$t('simulaciones.titulo')}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn  color="primary" dark @click="obtener_lista_simulaciones">{{$t('simulaciones.boton.recargar')}}</v-btn>
            
  
          </v-toolbar>
        </template>
        -->

        <template v-slot:item="{ item }">
          
          <tr>
          <td>{{ item.id }}</td>
          <td style="width: 400px; min-width: 200px;">
            
            <v-textarea
              v-model="item.name"
              variant="outlined"
              density="compact"
              hide-details
              rows="1"
              auto-grow
              class="name-field-wrap"
              @change="cambiarNombre(item)"
            />
            
            </td>        

          <td style="width: 400px; min-width: 200px;">
            
            <v-textarea
              v-model="item.project"
              variant="outlined"
              density="compact"
              hide-details
              rows="1"
              auto-grow
              class="name-field-wrap"
              @change="cambiarProyecto(item)"
            />
            
            </td>        


          <td>{{ item.username }}</td>
                     
          <td>{{ item.status !== -1 ? calcularHoraLocal(item.last_update) : item.last_update }}</td>
          <!--<td>{{ this.decodifica_estado(item.status) }}</td>-->
          <td>
          
          <v-icon 
            v-if="item.status === 3" 
            class="spin-icon" 
            color="blue"
          >
            mdi-loading
          </v-icon>
  
          <v-icon v-else-if="item.status === 4" color="green">mdi-check-circle</v-icon>
          <v-icon v-else-if="item.status === -1" color="orange">mdi-pencil</v-icon>
          </td>
          <td>{{ item.scanning }}</td> 
          
  
<td class="text-center">
  <div class="icon-container">
    <!-- Ícono para "Ver Resultado" -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          v-if="item.status === 4" 
          color="blue" 
          @click="ver_resultado_simulacion(item)"
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
        >
          mdi-eye
        </v-icon>


        <v-icon 
          v-if="item.status === -1" 
          color="blue" 
          @click="seguir_editando_simulacion(item)"
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
        >
          mdi-eye
        </v-icon>

      </template>
      {{$t('simulaciones.boton.ver_resultado')}}
    </v-tooltip>

    <!-- Ícono para "Borrar Simulación" -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon 
          v-if="item.status === 4" 
          color="red" 
          @click="borrar_simulacion(item)" 
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
        >
          mdi-delete
        </v-icon>

        <v-icon 
          v-if="item.status === -1" 
          color="red" 
          @click="borrar_simulacion_guardada(item)" 
          v-bind="attrs" 
          v-on="on"
          class="clickable-icon"
        >
          mdi-delete
        </v-icon>


      </template>
      {{$t('simulaciones.boton.borrar_simulacion')}}
    </v-tooltip>
  </div>
</td>


          </tr> 
  
        </template>

        </v-data-table>
       
       

  </v-container>








</template>


<script>
import store from '../store';
import axios from 'axios';
import '@vuepic/vue-datepicker/dist/main.css'
import ComponenteLoading from './ComponenteLoading.vue';
import Swal from "sweetalert2";
import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {




    data() {
        return {
          vista_operador: false,
          usuarios_operadores: [],
          usuario: store.state.usuarioNombre,
          search: null,

          mensaje_loading: "",
          loading: false,
          contenido: 'hola mundo', // Definir las propiedades reactivas
          mode: 'light',

            lista_simulaciones: [],

            cabecera_tabla_simulaciones: [
              { title: "ID", key: 'id' },            
              { title: this.$t('simulaciones.tabla.nombre'), key: 'name' },            
              { title: this.$t('simulaciones.tabla.proyecto'), key: 'project' }, 
              { title: this.$t('simulaciones.tabla.usuario'), key: 'username' },              
              { title: this.$t('simulaciones.tabla.fecha'), key: 'last_update' },
              { title: this.$t('simulaciones.tabla.estado'), key: 'status' }, 
              { title: this.$t('simulaciones.tabla.barridos'), key: 'scanning' },              
              { title: this.$t('simulaciones.tabla.acciones'), key: 'actions', sortable: false },
            ],



          isSaving: false,
            
          usuario_id: store.state.usuarioID,

          dialog: false,
          dialog_proceso: false,
          editedIndex: -1,


         
        };
      },

  watch: {    
    
    '$i18n.locale'() {
      
      this.cabecera_tabla_simulaciones = [
        { title: this.$t('simulaciones.tabla.nombre'), key: 'name' },            
        { title: this.$t('simulaciones.tabla.proyecto'), key: 'project' },            
        { title: this.$t('simulaciones.tabla.usuario'), key: 'username' },              
        { title: this.$t('simulaciones.tabla.fecha'), key: 'last_update' },
        { title: this.$t('simulaciones.tabla.estado'), key: 'status' },  
         { title: this.$t('simulaciones.tabla.barridos'), key: 'scanning' },               
        { title: this.$t('simulaciones.tabla.acciones'), key: 'actions', sortable: false },
      ];



    },



  },


  components: {
    ComponenteLoading,
  },
    mounted(){

        
        this.obtener_lista_simulaciones()

    },


    
    methods: {

      async cambiarNombre(item){


        const result = await Swal.fire({
          title: this.$t('mensajes.estas_seguro'),
          text: this.$t('mensajes.cambiar_nombre_simulacion') + item.id,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('comun.boton_ok'),
          cancelButtonText: this.$t('comun.boton_cancelar'),
        });

        if (result.isConfirmed) {

          this.loading = true;     
          this.mensaje_loading = ""
          axios(
              {
                  method: 'post',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/simulacion/nombre/',    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  }, 
                  data: {
                    "id": item.id,
                    "uuid": item.uuid,
                    "nuevo_nombre": item.name
                  }     
              }
          )
          .then(() => {    
              this.loading = false;     
              this.mensaje_loading = ""
          })


        } else {
          this.obtener_lista_simulaciones()
        }

        /*
        if (item.id == ""){ // Simulacion guardada
          alert("Es una simulacion guardada: " + item.name + " / " + item.id + " / " + item.uuid)
        }else{ // Simulacion terminada
          alert("Es una simulacion terminada: " + item.name + " / " + item.id + " / " + item.uuid)
        }
        */
      },


      async cambiarProyecto(item){


        const result = await Swal.fire({
          title: this.$t('mensajes.estas_seguro'),
          text: this.$t('mensajes.cambiar_proyecto_simulacion') + item.id,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t('comun.boton_ok'),
          cancelButtonText: this.$t('comun.boton_cancelar'),
        });

        if (result.isConfirmed) {

          this.loading = true;     
          this.mensaje_loading = ""
          axios(
              {
                  method: 'post',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/simulacion/proyecto/',    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  }, 
                  data: {
                    "id": item.id,
                    "uuid": item.uuid,
                    "nuevo_proyecto": item.project,
                    "nombre": item.name,
                  }     
              }
          )
          .then(() => {    
              this.loading = false;     
              this.mensaje_loading = ""
          })


        } else {
          this.obtener_lista_simulaciones()
        }

        /*
        if (item.id == ""){ // Simulacion guardada
          alert("Es una simulacion guardada: " + item.name + " / " + item.id + " / " + item.uuid)
        }else{ // Simulacion terminada
          alert("Es una simulacion terminada: " + item.name + " / " + item.id + " / " + item.uuid)
        }
        */
      },




      decodifica_estado(estado){
        if (estado == 1) return this.$t('simulaciones.estados.creada');
        if (estado == 2) return this.$t('simulaciones.estados.guardada');
        if (estado == 3) return this.$t('simulaciones.estados.en_ejecucion');
        if (estado == 4) return this.$t('simulaciones.estados.ejecutada_ok');
        if (estado == 5) return this.$t('simulaciones.estados.ejecutada_nok');
        if (estado == 6) return this.$t('simulaciones.estados.cancelada');
        if (estado == 7) return this.$t('simulaciones.estados.borrada');        
      },



      obtener_lista_simulaciones(){
        

          this.loading = true;
          this.mensaje_loading = this.$t('mensajes.obteniendo_lista');
          axios(
              {
                  method: 'get',
                  url: process.env.VUE_APP_API_BASE_URL + '/api/simulacion?username=' + store.state.usuarioNombre,    
                  withCredentials: true,                   
                  headers: { 
                    Authorization: "Bearer " + store.state.token,
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json'                
                  },      
              }
          )
          .then((response) => {    
              this.cargando = false;
              let myObject = response.data;
              this.lista_simulaciones = myObject.filter(item => item.status !== 7); //Que no muestre las borradas
              this.loading = false;     
              this.mensaje_loading = ""
          })



      },

      nueva_simulacion(){
        this.$router.push('/nueva-simulacion');
      },

      abrir_configuracion(){
        this.$router.push('/configuracion');
      },


      ver_resultado_simulacion(item){
        console.log(JSON.stringify(item))
        this.$router.push('/resultado-simulacion/' + item.id);
      },

      seguir_editando_simulacion(item){
        console.log(JSON.stringify(item))
        this.$router.push('/simulacion/' + item.uuid);
      },



    async borrar_simulacion(item) {

      try {
        

        this.errorMessage = null;
                
        try {
          const result = await Swal.fire({
            title: this.$t('mensajes.estas_seguro'),
            text: this.$t('mensajes.borrar_simulacion') + item.id,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t('comun.boton_ok'),
            cancelButtonText: this.$t('comun.boton_cancelar'),
          });

          if (result.isConfirmed) {
            this.loading = true;
            
            // Enviar los datos al servidor            
            await axios({
              method: "delete",
              url: process.env.VUE_APP_API_BASE_URL + "/api/borrar-simulacion/" + item.id,
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json'
              },
            });
                      
            this.loading = false;
            this.obtener_lista_simulaciones()
            // Mostrar mensaje de éxito
            Swal.fire(this.$t('mensajes.borrar_simulacion_ok_titulo'), this.$t('mensajes.borrar_simulacion_ok_subtitulo'), "success");
            this.$router.push('/'); //Nos vamos a la pagina de home
          }
        } catch (error) {
          console.error("Error al borrar la simulación:", error);
          this.loading = false;

          // Mostrar mensaje de error
          Swal.fire("Error", this.$t('mensajes.borrar_simulacion_nok'), "error");
        }
        
      } catch (error) {
        // Maneja errores de validación
        this.errorMessage = error.inner.map((e) => e.message).join(", ");
        console.error("Errores de validación:", this.errorMessage);
        Swal.fire("Errores de validacion", this.errorMessage, "error");
      }








    },


    async borrar_simulacion_guardada(item) {

      try {
        

        this.errorMessage = null;
                
        try {
          const result = await Swal.fire({
            title: this.$t('mensajes.estas_seguro'),
            text: this.$t('mensajes.borrar_simulacion') + item.id,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t('comun.boton_ok'),
            cancelButtonText: this.$t('comun.boton_cancelar'),
          });

          if (result.isConfirmed) {
            this.loading = true;
            
            // Enviar los datos al servidor            
            await axios({
              method: "delete",
              url: process.env.VUE_APP_API_BASE_URL + "/api/borrar-simulacion-guardada/" + item.uuid + "/",
              withCredentials: true,
              headers: {
                Authorization: "Bearer " + store.state.token,
                "Access-Control-Allow-Origin": "*",
                'Content-Type': 'application/json'
              },
            });
                      
            this.loading = false;
            this.obtener_lista_simulaciones()
            // Mostrar mensaje de éxito
            Swal.fire(this.$t('mensajes.borrar_simulacion_ok_titulo'), this.$t('mensajes.borrar_simulacion_ok_subtitulo'), "success");
            this.$router.push('/'); //Nos vamos a la pagina de home
          }
        } catch (error) {
          console.error("Error al borrar la simulación:", error);
          this.loading = false;

          // Mostrar mensaje de error
          Swal.fire("Error", this.$t('mensajes.borrar_simulacion_nok'), "error");
        }
        
      } catch (error) {
        // Maneja errores de validación
        this.errorMessage = error.inner.map((e) => e.message).join(", ");
        console.error("Errores de validación:", this.errorMessage);
        Swal.fire("Errores de validacion", this.errorMessage, "error");
      }








    },



    calcularHoraLocal(fechaString) {
        // Convertir la fecha del string al formato Date
        const fechaUTC = new Date(fechaString.replace(" ", "T") + "Z");
        
        // Obtener la fecha local en formato ISO
        const fechaLocal = new Date(fechaUTC.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }));

        // Formatear la fecha local al mismo formato que el original
        const year = fechaLocal.getFullYear();
        const month = String(fechaLocal.getMonth() + 1).padStart(2, "0");
        const day = String(fechaLocal.getDate()).padStart(2, "0");
        const hours = String(fechaLocal.getHours()).padStart(2, "0");
        const minutes = String(fechaLocal.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    },

    async descargarReadme() {
      const zip = new JSZip();
      const docsFolder = zip.folder("docs"); // Carpeta dentro del ZIP
      const assetsFolder = zip.folder("docs/assets"); // Carpeta de imágenes

      try {
      
        const readmeResponse = await axios.get("/docs/README.md", {
          responseType: "text",
        });
        docsFolder.file("README.md", readmeResponse.data);

        const imagenes = await this.obtenerListaImagenes();

        for (const img of imagenes) {
          const imgResponse = await axios.get(`/docs/assets/${img}`, {
            responseType: "blob",
          });
          const imgBlob = new Blob([imgResponse.data]);
          const arrayBuffer = await imgBlob.arrayBuffer();
          assetsFolder.file(img, arrayBuffer);
        }
        const zipBlob = await zip.generateAsync({ type: "blob" });
        saveAs(zipBlob, "ralph_manual.zip");

      } catch (error) {
        console.error("Error al descargar el README o las imágenes", error);
      }
    },

    async obtenerListaImagenes() {
      try {
        const response = await axios.get("/docs/assets/"); 
        return response.data; 
      } catch (error) {
        console.error("Error al obtener la lista de imágenes:", error);
        return []; 
      }
    },



    },



    created() {
        // Cargar configuración proporcionada desde `main.js`
        fetch('/config.json')
          .then((response) => response.json())
          .then((config) => {
            this.usuarios_operadores = config.usuarios_operadores;                  
            if (this.usuarios_operadores.includes(this.usuario)) {
                this.vista_operador = true;
            } else {
                this.vista_operador = false;
            }
                     
          })
          .catch((error) => {
            console.error('Error al cargar la configuración:', error);
            
          });
      },      



}
</script>


<style scoped>
.name-field-wrap textarea {
  line-height: normal;
}




/* Animación simple para el ícono */
.spin-icon {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}



.boton_crear{
      background-color: #1867C0 !important;
      color:white !important
    }
    .boton_crear:hover {
      background-color: #F2F2F2 !important;/* Indigo-700 */
      color: #1867C0 !important;
    }
    .boton_crear:active {
      background-color: #CDCDCD; /* Indigo-800 */
    }


    .gris_medio{
      color:#686868 !important;
    }

@media (max-width: 1024px) {
  .mx-2.gris_medio .v-btn__content {
    font-size: 0; /* oculta texto */
  }
  .mx-2.gris_medio .material-symbols-outlined {
    font-size: 20px;
    margin: 0;
  }
}


@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined');
.material-symbols-outlined {
  font-variation-settings:
    'FILL' 0,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24;
  font-size: 24px;
  vertical-align: left;
}




</style>